module.exports = __webpack_public_path__ + "media/src/images/icons/gray_circle-c3b434654cd18aef06df9913e8510ad2.svg";